export default state=>{
  if(state.guidance?.resource)   
  {
    const resources=toArray(state.guidance.resource);
    const resourcesMap={EverydayCare:[],ChronicCare:[],FamilyPlanning:[]};
    resources.forEach(res=>{
      if(res.footNotes)
      {
        res.footNotes=toArray(res.footNotes);
      }
      else{
        res.footNotes=[];
      }
      if(res.subsection=="EverydayCare")
      {
        resourcesMap.EverydayCare.push(res);
      }
      if(res.subsection=="ChronicCare")
      {
        resourcesMap.ChronicCare.push(res);
      }
      if(res.subsection=="FamilyPlanning")
      {
        resourcesMap.FamilyPlanning.push(res);
      }

    });
    state.guidance.resourcesMap=resourcesMap;
  } 
  
};

function toArray(val) {
  return Array.isArray(val) ? val : val?[val]:[];
}
  